import { useDocs } from './Docs.h'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Doc from './Doc'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Divider from '@mui/material/Divider'

export default function Docs() {
    const {
        doc,
        setDoc,
        contentRef,
        tabValue,
        setTabValue,
        resolvedDocs,
        user,
        docRef,
        viewFields,
        generating,
        handleAdd,
        handleSelection
    } = useDocs()

    return (
        <>
            <DialogTitle>
                {!doc
                    ? 'النماذج'
                    : (
                        <>
                            {doc.text}
                            <Typography
                                sx={{ display: 'block' }}
                                variant='caption'
                            >ملاحظة: يمكنك عمل zoom في الصورة.</Typography>
                        </>
                    )
                }
            </DialogTitle>
            {!doc &&
                <>
                    <Tabs
                        value={tabValue}
                        onChange={(e, v) => setTabValue(v)}
                    >
                        <Tab value='def' label='DEF'/>
                        <Tab value='pdc' label='PDC'/>
                    </Tabs>
                    <Divider />
                </>
            }
            <DialogContent ref={contentRef} sx={{p: 0}}>
                <List sx={{display: !doc ? 'block' : 'none'}}>
                    {(tabValue == 'def' ? resolvedDocs.def : resolvedDocs.pdc).map(d => (
                        <ListItemButton
                            key={d.text}
                            sx={{px: 3}}
                            onClick={() => handleSelection(d)}
                            divider
                            disabled={!user.first_name}
                        >
                            <ListItemText primary={d.text}/>
                        </ListItemButton>
                    ))}
                </List>
                {!!doc && <Doc ref={docRef} doc={doc} />}
            </DialogContent>
            <DialogActions>
                {!doc
                    ? (
                        <Button variant='text' onClick={viewFields}>رجوع</Button>
                    ) : (
                        <>
                            <Button variant='text' onClick={() => setDoc(null)} disabled={generating}>رجوع</Button>
                            <Button variant='text' onClick={handleAdd} disabled={generating}>
                                {generating ? 'جارِ الإنشاء...' : 'إضافة'}
                            </Button>
                        </>
                    )
                }
            </DialogActions>
        </>
    )
}